import React from 'react';
import PropTypes from 'prop-types';
import Svg, { Path, Circle } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function SearchIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="-1 -1 19 22"
    >
      <Circle
        cx={7}
        cy={7}
        r={7}
        stroke={color}
        fill="none"
      />
      <Path
        d="M11.5,12.5 L17.5,20.5"
        stroke={color}
        fill="none"
      />
    </Svg>
  );
}

SearchIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

SearchIcon.defaultProps = {
  height: 19,
  width: 22,
};

export default pure(SearchIcon);
